import PrimaryButton from "../PrimaryButton";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { loginWithOTP } from "../../apis/otp";
import { useCookies } from "react-cookie";
import { convertPhoneNumber } from "../../utils/phone-number";

export default function VerifyOTPLoginButton({
  errorOTP,
  OTPValue,
  setErrorOTP,
  emailPhoneValue,
  navigateTo,
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\+?[0-9]\d{9}$/;
  const [cookies, setCookie] = useCookies(["access_token"]);

  const handleSendOTP = async () => {
    if (!emailPhoneValue) navigate("/loginotp");

    if (!emailRegex.test(emailPhoneValue) && !phoneRegex.test(emailPhoneValue))
      navigate("/loginotp");

    if (!OTPValue) {
      setErrorOTP("invalid_otp");
      return;
    }

    if (OTPValue.length != 6) {
      setErrorOTP("invalid_otp_length");
      return;
    }

    if(phoneRegex.test(emailPhoneValue)) emailPhoneValue = convertPhoneNumber(emailPhoneValue)

    const result = await loginWithOTP(emailPhoneValue, OTPValue)

    if (result.status === 200) {
      const success = result.data;
      let expires = new Date()
      expires.setTime(expires.getTime() + (7 * 24 * 60 * 60 * 1000))

      setCookie('access_token', success.token, { path: '/', expires: expires, maxAge: 7 * 24 * 60 * 60, secure: true, sameSite: 'strict'})
    } else {
      if (result.status === 401) {
        setErrorOTP("invalid_otp")
        return
      }

      if (result.status !== 500) setErrorOTP(result.statusText)
      else setErrorOTP("api_error")
      return
    }

    // Redirect user
    setTimeout(() => {
      navigate(navigateTo);
    }, 1000);
  };

  return <PrimaryButton text={t("login")} onClick={handleSendOTP} />;
}
